import React from "react";
import { Modal, Tabs, Button, Popconfirm, Space, Spin } from "antd";
import { RiSoundModuleFill } from "react-icons/ri";
import { useAlertConfig } from "./hooks/useAlertConfig";
import VitalThresholds from "./components/VitalThresholds";
import SosConfig from "./components/SosConfig";
import BatteryConfig from "./components/BatteryConfig";
import DurationConfig from "./components/DurationConfig";
import ProtectionZoneConfig from "./components/ProtectionZoneConfig";
import EquipmentConfig from "./components/EquipmentConfig";
import TripwireConfig from "./components/TripwireConfig";

const AlertConfigModal = ({ open, onClose, machineID }) => {
  const { loading, saving, fields, setField, save, reset } = useAlertConfig(
    machineID,
    open,
  );

  if (!open) return null;

  const tabs = [
    {
      key: "vitals",
      label: "生命體徵",
      children: <VitalThresholds fields={fields} setField={setField} />,
    },
    {
      key: "sos",
      label: "SOS",
      children: <SosConfig fields={fields} setField={setField} />,
    },
    {
      key: "battery",
      label: "電量",
      children: <BatteryConfig fields={fields} setField={setField} />,
    },
    {
      key: "duration",
      label: "停留偵測",
      children: <DurationConfig fields={fields} setField={setField} />,
    },
    {
      key: "protection_zone",
      label: "防護區",
      children: <ProtectionZoneConfig fields={fields} setField={setField} />,
    },
    {
      key: "equipment",
      label: "機具",
      children: <EquipmentConfig fields={fields} setField={setField} />,
    },
    {
      key: "tripwire",
      label: "越線",
      children: <TripwireConfig fields={fields} setField={setField} />,
    },
  ];

  return (
    <Modal
      title={
        <Space>
          <RiSoundModuleFill />
          <span>警報設定</span>
        </Space>
      }
      open={open}
      onCancel={onClose}
      width={600}
      footer={
        <div className="d-flex justify-content-between">
          <Popconfirm
            title="確認重置為系統預設值？"
            onConfirm={reset}
            okText="確認"
            cancelText="取消"
          >
            <Button danger loading={saving}>
              重置預設值
            </Button>
          </Popconfirm>
          <Space>
            <Button onClick={onClose}>取消</Button>
            <Button type="primary" onClick={save} loading={saving}>
              儲存
            </Button>
          </Space>
        </div>
      }
    >
      <Spin spinning={loading}>
        <Tabs items={tabs} />
      </Spin>
    </Modal>
  );
};

export default AlertConfigModal;
